import __request__ from 'routing/request';
interface IndexRangeSummary {
    readonly took_ms: number;
    readonly end: string;
    readonly calculated_at: string;
    readonly index_name: string;
    readonly begin: string;
}
interface Type {
    readonly type_name: string;
}
interface ChunkedOutput_ResultChunk {
    readonly raw_type: string;
    readonly closed: boolean;
    readonly type: Type;
}
interface SearchDecorationStats {
    readonly added_fields: string[];
    readonly changed_fields: string[];
    readonly removed_fields: string[];
}
interface DecorationStats {
    readonly added_fields: {
        readonly [_key: string]: Object;
    };
    readonly changed_fields: {
        readonly [_key: string]: Object;
    };
    readonly removed_fields: {
        readonly [_key: string]: Object;
    };
}
interface ResultMessageSummary {
    readonly decoration_stats: DecorationStats;
    readonly index: string;
    readonly highlight_ranges: {
        readonly [_key: string]: unknown[];
    };
    readonly message: {
        readonly [_key: string]: Object;
    };
}
interface SearchResponse {
    readonly used_indices: IndexRangeSummary[];
    readonly decoration_stats: SearchDecorationStats;
    readonly query: string;
    readonly messages: ResultMessageSummary[];
    readonly from: string;
    readonly to: string;
    readonly time: number;
    readonly fields: string[];
    readonly built_query: string;
    readonly total_results: number;
}
/**
 * Message search with relative timerange.
 * @param query Query (Lucene syntax)
 * @param range Relative timeframe to search in. See method description.
 * @param limit Maximum number of messages to return.
 * @param offset Offset
 * @param batch_size Batch size for the backend storage export request.
 * @param filter Filter
 * @param streams Comma separated list of streams to search in
 * @param fields Comma separated list of fields to return
 */
export function searchRelativeChunked(query: string, range: number, fields: string, limit?: number, offset?: number, batch_size: number = 500, filter?: string, streams?: string): Promise<ChunkedOutput_ResultChunk> {
    return __request__('GET', '/search/universal/relative', null, { 'query': query, 'range': range, 'limit': limit, 'offset': offset, 'batch_size': batch_size, 'filter': filter, 'streams': streams, 'fields': fields }, {
        'Accept': ['text/csv']
    });
}
/**
 * Message search with relative timerange.
 * @param query Query (Lucene syntax)
 * @param range Relative timeframe to search in. See method description.
 * @param limit Maximum number of messages to return.
 * @param offset Offset
 * @param filter Filter
 * @param fields Comma separated list of fields to return
 * @param streams Comma separated list of stream IDs to search in
 * @param sort Sorting (field:asc / field:desc)
 * @param decorate Run decorators on search result
 */
export function searchRelative(query: string, range: number, limit?: number, offset?: number, filter?: string, fields?: string, streams?: string, sort?: string, decorate: boolean = true): Promise<SearchResponse> {
    return __request__('GET', '/search/universal/relative', null, { 'query': query, 'range': range, 'limit': limit, 'offset': offset, 'filter': filter, 'fields': fields, 'streams': streams, 'sort': sort, 'decorate': decorate }, {
        'Accept': ['application/json']
    });
}
/**
 * Export message search with relative timerange.
 * @param query Query (Lucene syntax)
 * @param range Relative timeframe to search in. See method description.
 * @param limit Maximum number of messages to return.
 * @param offset Offset
 * @param batch_size Batch size for the backend storage export request.
 * @param filter Filter
 * @param streams Comma separated list of streams to search in
 * @param fields Comma separated list of fields to return
 */
export function exportSearchRelativeChunked(query: string, range: number, fields: string, limit?: number, offset?: number, batch_size: number = 500, filter?: string, streams?: string): Promise<unknown> {
    return __request__('GET', '/search/universal/relative/export', null, { 'query': query, 'range': range, 'limit': limit, 'offset': offset, 'batch_size': batch_size, 'filter': filter, 'streams': streams, 'fields': fields }, {
        'Accept': ['text/csv']
    });
}
